import { Filter, FiltersPayload, Sort } from '../../types/filteringAndSort';
import { ModalActions } from '../../models/Modal';
import { TableSortOrder } from '../../utils/constants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PRODUCTS_COLUMNS } from '../../../modules/products/helpers/consts';
import { ProductT } from '../../types/product';

type ProductsSliceStateT = {
  page: number;
  arrangeId: PRODUCTS_COLUMNS | null;
  sorting: Sort;
  filtering: Filter;

  modalType: ModalActions | null;
  isModalOpen: boolean;
  selectedProduct: ProductT | null;
};

const initialState: ProductsSliceStateT = {
  page: 1,
  arrangeId: null,
  sorting: {
    sortOrder: TableSortOrder.NONE,
    sortFieldName: null,
    withSorting: true,
  },
  filtering: {
    filterFieldName: null,
    filter: [],
    filtersWithLabels: [],
  },
  isModalOpen: false,
  modalType: null,
  selectedProduct: null,
};

export type ProductsFiltersPayload = FiltersPayload & {
  arrangeId: PRODUCTS_COLUMNS;
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setModalOpened: (state, action: PayloadAction<ModalActions>) => {
      state.modalType = action.payload;
      state.isModalOpen = true;
    },
    setModalClosed: (state) => {
      state.modalType = null;
      state.isModalOpen = false;
    },
    setCurrentProduct: (state, action: PayloadAction<ProductT | null>) => {
      state.selectedProduct = action.payload;
    },
    setFilters: (state, action: PayloadAction<ProductsFiltersPayload>) => {
      state.arrangeId = action.payload.arrangeId;
      state.sorting = action.payload.sorting;
      state.filtering = action.payload.filtering;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    resetFields: (state) => {
      state.arrangeId = null;
      state.sorting = {
        sortOrder: TableSortOrder.NONE,
        sortFieldName: null,
        withSorting: true,
      };
      state.filtering = {
        filterFieldName: null,
        filter: [],
      };
    },
  },
});

export const { setFilters, setPage, setCurrentProduct, setModalClosed, setModalOpened, resetFields } =
  productsSlice.actions;
export const products = productsSlice.reducer;
